export { DocumentDownload as default } from './DocumentDownload';
